let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dZP0H")).then(() => parcelRequire('27cu9'));